var Model = require("../types/DebouncedModel.js");
var Set = require("es6-set");
var not = require("not");
var isObject = require("isobject");
var Promise = require("promise");

var MAX_AT_ONCE = 300;

/**
 * @module People
 * @description Keeps track of the information of arbitrary users.  Expects config
 * to be empty or undefined
 * @type {Model}
 */
module.exports = Model({
	name: "people",
	_users: null,
	_timestamp: null,

	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
	debounce: 200, // Debounce pushes by 50 milliseconds

	add: add,
	listen_users: listen_users,
	fetch_user_data: fetch_user_data,
	__loading: null

});

/**
 * Sets up the mqtt listeners array and pushes an empty object as the state
 * @return {[type]} [description]
 */
function init() {
	this._users = new Set();
}

/**
 * Removes all listeners for mqtt messages on the dispatcher
 * @return {Promise} Resolves when done
 */
function uninit() {
	this._users = null;
}

function triggers() {
	return {
		"add": add
	};
}

function listeners() {
	return {
		"connectivity:online": refresh_all
	};
}

/**
 * Refreshes the status of all users being tracked
 */
function refresh_all() {
	var timestamp = this._timestamp;
	var who = set_to_array(this._users);
	this.fetch_user_data(who, timestamp);
}

/**
 * Starts tracking the state of another user/users
 * @param {Array|String} who Either an id or an array of ids to start tracking
 */

function add(who) {
	if (this._loading)
		return this._loading.then(add.bind(this, who));
	var lean = false;
	if (isObject(who)) {
		lean = !!who.lean;
		who = who.who; // Handle for event case
	}

	if(!who) return;
	if (!(who[0])) return;

	if (!who.filter)
		who = [].concat(who);

	var users = this._users; // Get a reference to the set of all current users

	this.emit("availability:trigger:add", {
		who: who
	});

	who = who.filter(not(users.has.bind(users))); // Filter out any users that have allready been added

	if (who.length) {
		who.forEach(users.add.bind(users)); // Add any new users to the set
		this.listen_users(who);
		return this.fetch_user_data(who);
	} else if (!lean) this.extend({});
}

/**
 * Listens for changes in users' settings.
 * @param  {Array} users Array of user ids to listen to
 */
function listen_users(users) {
	users.map(listen_user.bind(this));
}

/**
 * Listens for changes in a user's settings
 * @param  {String} who Id of the user to listen to
 */
function listen_user(who) {
	var self = this;
	var tracker = this.tracker;

	tracker.on("mqtt:u/" + who + "/settings", handle_user_change);
	tracker.on("mqtt:u/" + who + "/destroyed", handle_user_destroyed);

	function handle_user_change(data) {
		if(data && !Object.keys(data).includes("versionInfo"))
			self.fetch_user_data(who);
	}

	function handle_user_destroyed() {
		self.dispatch("destroyed", {
			who: who
		});
		this.emit("contactprofile:trigger:currentdestroyed", {who: who});
		var update = {};
		update[who] = null;
		self.extend(update);
	}
}

/**
 * Fetches the data for a given set of users and updates the state
 * @param  {Array} who Array of user ids to fetch
 * @param  {Array} timestamp date object of most recent timestamp recorded in cache
 * @return {Promise}     Resolves when the state has been updated
 */
function fetch_user_data(who, timestamp) {
	this.emit("save:trigger:start");
	var chunks = [];
	var total = who.length;
	var group = 0;
	while (group < total) {
		chunks.push(who.slice(group, group + MAX_AT_ONCE));
		group += MAX_AT_ONCE;
	}

	return Promise.all(chunks.map(function (chunk) {
		if (!chunk.length) return [];
		return this.api.people.public(chunk, timestamp);

	}, this))
		.then(flatten)
		.then(make_update_map)
		.then(checkUpdated.bind(this))
		.then(this.extend.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));
}



function finish_save() {
	this.emit("save:trigger:finish");
}

/**
 * Takes a list of user data and builds a map from their ids
 * @param  {Array} data Array of user data to process
 * @return {Object}      Map of id->object of the users's data
 */
function make_update_map(data) {
	return data.reduce(function (result, user) {
		result[user._id] = user;
		return result;
	}, {});
}

// Converts a set to an array
function set_to_array(set) {
	var result = [];
	set.forEach(function (item) {
		result.push(item);
	});
	return result;
}

function checkUpdated(data) {
	return data;
}

function flatten(list) {
	return list.reduce(function (a, b) { return a.concat(b); }, []);
}